import React from 'react'
import { useSelector } from 'react-redux'
import NoticeBar from 'components/NoticeBar'
import styles from 'components/AppNotices/styles.less'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors'
import { selectCurrentUserId } from 'ducks/currentUser/selectors/selectCurrentUserId'
import { selectAccountId } from 'ducks/accounts/selectors/selectAccountId'
import { bannerForStatus } from './model'
import useLinkStatus from './useLinkStatus'

export default function HelplyMigrationBanner() {
  const manager = useSelector(selectCurrentUserIsAdminOrOwner)
  const userId = useSelector(selectCurrentUserId)
  const accountId = useSelector(selectAccountId)
  const status = useLinkStatus(
    `${accountId}:${userId}`,
    !!(manager && accountId && userId)
  )
  const banner = manager && bannerForStatus(status)
  if (!banner) return null

  return (
    <NoticeBar dismissible={false}>
      <strong className={styles.demoBarHeader}>{banner.heading}</strong>
      {banner.text}
      <a href={banner.href} className={styles.buttonLink}>
        {banner.action}
      </a>
    </NoticeBar>
  )
}
